var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-facility-sections"},[_c('tabbed-view',{attrs:{"tabs":_vm.tabs,"fixed-title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }